var App = App || {};

App.SiteHeader = (function ($) {
    "use strict";

    var Bps = ["xs", "sm", "md"],
        Bp = ZAGFramework.GetCurrentBP(),
        ocPadTop = 35;

    function init() {
        Search();
        PrimaryNav();

        //fake absolute positioning for offcanvas-offset menus
        //because bootstrap closes true absolutely positioned offcanvas menus on window resize in a way that we cannot circumvent
        $(window).scroll(function () {
            $(".offcanvas.offcanvas-offset").css("top", 0 - $(window).scrollTop())
        });

        $(".offcanvas.offcanvas-offset *").focus(
            function () {
                var windowIsBelowElement = $(window).scrollTop() > $(this).offset().top;
                var windowIsAboveElement = $(window).scrollTop() + $(window).height() < $(this).offset().top + $(this).outerHeight()
                if (windowIsBelowElement || windowIsAboveElement) {
                    window.scrollTo(0, $(this).offset().top)
                }
            }
        );

        /**********************************************************************************
         Whats New Menu
        /*********************************************************************************/
        $("#WhatsNewMenu").appendTo("body");
        $("#WhatsNewMenu").on("show.bs.offcanvas", function () {
            Bp = ZAGFramework.GetCurrentBP();
            ocPadTop = $("#site-header").offset().top + $("header").height() + 35;
            if (Bps.includes(Bp)) {
                ocPadTop = $("#site-header").offset().top + $("header").height() + 15;
            }
            $("#WhatsNewMenu").css("padding-top", ocPadTop);
        });

        $(".btn-whats-new").hover(
            function () {
                var WNBtn = $(this);
                WNBtn.removeClass("animate__heartBeat2");
                setTimeout(function () {
                    WNBtn.addClass("animate__heartBeat2");
                }, 50);
            }, function () {
                var WNBtn = $(this);
                WNBtn.removeClass("animate__heartBeat2");
            }
        );


        /**********************************************************************************
         Mobile Navigation
        /*********************************************************************************/
        var lvl1Menu = $("#site-header-mobile-menu-offcanvas"),
            mobileLevel2Buttons = $(".mobile-nav-btn-lvl2"),
            lvl3Nav = $(".offcanvas.offcanvas-lvl3");

        lvl1Menu.appendTo("body");
        lvl1Menu.on("show.bs.offcanvas", function () {
            ocPadTop = $("#site-header").offset().top + $("header").height() + 5;
            lvl1Menu.css("padding-top", ocPadTop);
        });

        lvl3Nav.on("show.bs.offcanvas", function () {
            ocPadTop = $("#site-header").offset().top + $("header").height() + 5;
            $(this).css("padding-top", ocPadTop);
            $(this).css("min-height", ocPadTop + lvl1Menu.height());
        });

        mobileLevel2Buttons.click(function () {
            var lvl2Offcanvas = new bootstrap.Offcanvas(document.getElementById($(this).attr("data-bs-target")));
            lvl2Offcanvas.show();

            //away class indicates lvl 1 menu is not in  view. data-lvl3-visited tracks last lvl 3 menu viewed
            lvl1Menu.addClass("away").attr("data-lvl3-visited", $(this).attr("data-bs-target"));
        });

        lvl3Nav.on('shown.bs.offcanvas', function () {
            $(this).find(".btn-back").focus();
        });

        lvl3Nav.on('hide.bs.offcanvas', function () {
            //prevent focus of menu button when using keyboard nav to returning to lvl 1 menu
            $(".btn-mobile-menu").addClass("anti-focus");
        });

        //close both mobile nav menus when lvl3 close is clicked
        $(".offcanvas-lvl3 .btn-close").click(function () {
            lvl1Menu.addClass("cascade-close");
        });

        lvl3Nav.on('hidden.bs.offcanvas', function () {
            if (lvl1Menu.hasClass("cascade-close")) {
                lvl1Menu.removeClass("cascade-close");
                $("#site-header-mobile-menu-offcanvas.show .btn-close.lvl1-close").click();
            } else {
                //data-bs-focus never works for first dismissal, but will after sometimes
                //here we force focus to last opened lvl 2 button even if button focus fails
                lvl1Menu.find(".mobile-nav-btn-lvl2[data-bs-target=" + lvl1Menu.attr("data-lvl3-visited") + "]").focus();
            }
        });

        lvl1Menu.on('hide.bs.offcanvas', function () {
            if (lvl1Menu.hasClass("away")) {
                //indicate lvl 1 is currently being viewed
                lvl1Menu.removeClass("away");
            }
            else {
                //allow header mobile nav button to be focused
                $(".btn-mobile-menu").removeClass("anti-focus").focus();
            }
        });

        $(document).on("focus", ".anti-focus", function () {
            //bootstrap defaults focusing header mobile nav button despite data-bs-focus being set to false (likely bug)
            //instead, when appropriate, we redirect focus to lvl 2 link associated with last opened lvl 3 menu
            lvl1Menu.find(".mobile-nav-btn-lvl2[data-bs-target=" + lvl1Menu.attr("data-lvl3-visited") + "]").focus();
        })

        //close mobile menu when entering desktop breakpoints
        var wasMobile = Bps.includes(Bp);
        $(window).resize(function () {
            Bp = ZAGFramework.GetCurrentBP();
            if (Bps.includes(Bp)) {
                wasMobile = true;
            } else {
                if (wasMobile) {
                    if (lvl3Nav.hasClass("show")) {
                        lvl3Nav.find(".btn-close").click();
                    } else if (lvl1Menu.hasClass("show")) {
                        lvl1Menu.find(".lvl1-close").click();
                    }
                }
                wasMobile = false;
            }
        });
    }

    function Search() {
        const searchOffcanvas = $("#site-header-search-offcanvas");
        const searchTextField = searchOffcanvas.find("input[type='text'].form-control");

        searchOffcanvas.on("shown.bs.offcanvas", function () {
            searchTextField.focus();
        });
    }

    function PrimaryNav() {

        var hovering = false;
        var megaMenuSpeed = 300;

        var selectorMenu = $(".site-header-primary > nav > ul");
        var selectorItems = $(".site-header-primary > nav > ul.level-1").children("li").children("a, button");

        var level2Menu = [];
        var level2MenuWhich = 0;
        var level2MenuList= $(".site-header-primary > nav > ul.level-2");
        var level2MenuItems = $(".site-header-primary > nav > ul.level-2").children("li");
        var level2MenuButtons = level2MenuItems.find("a.lvl-2-item-desktop, button.lvl-2-item-desktop");

        var level3MenuButtons = level2MenuItems.find("a.lvl-3-item-desktop, button.lvl-3-item-desktop");

        $(".site-header-primary").find(".mega-menu").each(function () {
            $(this).find("a").attr("tabindex", -2);
        });;

        /**********************************************************************************
         ENTIRE MENU END HOVER
        /*********************************************************************************/
        level2MenuList.hover(
            function () {
                hovering = true;
            },
            function () {
                hovering = false;
                level2MenuItems.blur();
            }
        );


        /**********************************************************************************
         LEVEL ONE ITEM CLICK
        /*********************************************************************************/

        selectorItems.click(
            function () {
                selectorItems.removeClass("open");
                $(this).addClass("open");
                $("ul.level-2.open").removeClass("open");
                $("#lvl2-menu-" + $(this).attr("data-page-id")).addClass("open")
            }
        );

        selectorItems.focus(
            function () {
                selectorItems.removeClass("open");
                $(this).addClass("open");
                $("ul.level-2.open").removeClass("open");
                $("#lvl2-menu-" + $(this).attr("data-page-id")).addClass("open")
            }
        );

        /**********************************************************************************
         LEVEL ONE ITEM ARROWS
        /*********************************************************************************/
        selectorItems.keydown(function (e) {
            // right arrow
            if (e.keyCode === 39) {
                e.preventDefault();
                $(this).parent("li").next("li").children("a, button").focus();
            }
            // left arrow
            else if (e.keyCode === 37) {
                e.preventDefault();
                $(this).parent("li").prev("li").children("a, button").focus();
            }
            // down arrow
            else if (e.keyCode === 40) {
                hovering = true;
                e.preventDefault();
                $("#lvl2-menu-" + $(this).attr("data-page-id")).children("li:first-child").children("a, button").focus();
            }
            // esc
            else if (e.keyCode === 27) {
                var MenuuButton = $(this);
                MmClose(MenuuButton, megaMenuSpeed);
            }
        });


        /**********************************************************************************
         LEVEL TWO ITEM HOVER
        /*********************************************************************************/

        level2MenuItems.hover(
            function () {
                if (hovering !== true) {
                    MmOpen($(this).find("a, button"), megaMenuSpeed);
                }
                else {
                    MmOpen($(this).find("a, button"), 1);
                }
            },
            function () { }
        );

        /**********************************************************************************
         LEVEL TWO BUTTONS FOCUS
        /*********************************************************************************/
        level2MenuButtons.focus(function () {
            MmOpen($(this), 1);
            hovering = true;
        });

        /**********************************************************************************
         LEVEL TWO ITEM BLUR
        /*********************************************************************************/
        level2MenuItems.blur(function () {
            if (hovering === false) {
                MmClose($(this).find("a, button"), megaMenuSpeed);
            }
        });

        /**********************************************************************************
         LEVEL TWO ITEM ARROWS
        /*********************************************************************************/
        level2MenuButtons.keydown(function (e) {
            // right arrow
            if (e.keyCode === 39) {
                e.preventDefault();
                $(this).parent("li").next("li").children("a, button").focus();
            }
            // left arrow
            else if (e.keyCode === 37) {
                e.preventDefault();
                $(this).parent("li").prev("li").children("a, button").focus();
            }
            // down arrow
            else if (e.keyCode === 40) {
                hovering = true;
                e.preventDefault();
                level2Menu = [];
                $(this).siblings(".mega-menu").find("a:visible, button:visible").each(function () { level2Menu.push(this); });
                level2MenuWhich = 0;
                $(level2Menu[level2MenuWhich]).focus();
            }
            // up arrow
            else if (e.keyCode === 38) {
                hovering = true;
                e.preventDefault();
                $("#lvl1-button-" + $(this).attr("data-page-id")).focus();
                
            }
            // esc
            else if (e.keyCode === 27) {
                var MenuuButton = $(this);
                MmClose(MenuuButton, megaMenuSpeed);
            }
        });

        /**********************************************************************************
         LEVEL THREE ITEM ARROWS
        /*********************************************************************************/
        level3MenuButtons.keydown(function (e) {
            // right arrow
            if (e.keyCode === 39) {
                e.preventDefault();
                $(this).parent("li").next("li").children("a, button").focus();
            }
            // left arrow
            else if (e.keyCode === 37) {
                e.preventDefault();
                $(this).parent("li").prev("li").children("a, button").focus();
            }
            // down arrow
            else if (e.keyCode === 40) {
                e.preventDefault();
            }
            // up arrow
            else if (e.keyCode === 38) {
                hovering = true;
                e.preventDefault();
                $(this).closest(".mega-menu").siblings("button").focus();
                
            }
            // esc
            else if (e.keyCode === 27) {
                var MenuuButton = $(this).closest(".mega-menu").siblings("button");
                MenuuButton.focus();
                MmClose(MenuuButton, megaMenuSpeed);
            }
        });


        /**********************************************************************************
         ENTIRE EVERYTHING KEYPRESS - should we close that menu??
        /*********************************************************************************/
        selectorMenu.keydown(function (e) {
            if (e.keyCode === 9) {
                hovering = false;
                MmClose($(this).children("li").children("a, button"), 1);
            }
        });
    }

    function MmOpen(Menu, Speed) {
        Menu.attr("aria-expanded", "true").addClass("active").siblings(".mega-menu").stop().slideDown(Speed);
        Menu.parents("li").siblings("li").children("a, button").removeClass("active");
        MmClose(Menu.parents("li").siblings("li").children("a, button"), Speed);
    }

    function MmClose(Menu, Speed) {
        Menu.parents("li").siblings("li").children("a.default, button.default").addClass("active");
        Menu.attr("aria-expanded", "false").removeClass("active").siblings(".mega-menu").stop().slideUp(Speed);
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.SiteHeader.init();
});